import {
  GET_PROFILE,
  PROFILE_ERROR,
  CLEAR_PROFILE,
  TASKS_ERROR,
  GET_TASKS,
  CLEAR_TASKS,
} from '../actions/types';

const initialState = {
  profile: null,
  userRoles: [],
  isAdmin: false,
  loading: true,
  error: {},
};

export default function userProfile(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_PROFILE:
      return {
        ...state,
        profile: payload,
        loading: false,
      };
    case PROFILE_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case CLEAR_PROFILE:
      return {
        ...state,
        profile: null,
        userRoles: [],
        isAdmin: false,
      };
    case GET_TASKS:
      return {
        ...state,
        tasks: payload,
        loading: false,
      };
    case TASKS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case CLEAR_TASKS:
      return {
        ...state,
        tasks: null,
      };
    default:
      return state;
  }
}
